var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Label } from 'reactstrap';
import { Button, Field, FieldType } from '../../../elements';
import cxs from 'cxs/component';
import { mediaQueries } from '../../../Theme';
import { loading } from '../../../elements/Loading';
import { Modules } from '../Model';
import { T, TT } from '../../../helpers/i18n';
import theme from '../../../Theme';
import Touchable from '../../../elements/Touchable';
import View from '../../../elements/View';
import history from '../../../helpers/History';
var ViewSelected = {
    settings: 'settings',
};
var AcountContainer = /** @class */ (function (_super) {
    __extends(AcountContainer, _super);
    function AcountContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            beCollaborator: false,
            primaryMoney: null,
            webMoney: null,
            viewSelected: ViewSelected.settings,
            updateLast: null,
            updateAvailable: null,
            isUpToDate: true,
            currentVersion: null
        };
        _this.modules = __spreadArray([
            {
                name: T(Modules.Collaborator),
                column: Modules.Collaborator,
                route: 'moduleCollaborator',
                status: 'hh',
                description: T('descriptionCollabortorModule')
            },
            {
                name: T(Modules.Virtual),
                column: Modules.Virtual,
                route: 'moduleVirtual',
                status: 'active',
                description: T('descriptionVirtualModule')
            },
            {
                name: T('moduleEcommerce'),
                column: Modules.Ecommerce,
                route: 'moduleEcommerce',
                status: 'active',
                description: T('descriptionEcommerceModule')
            },
            {
                name: T('moduleApp'),
                column: Modules.App,
                route: 'moduleApp',
                status: 'active',
                description: T('descriptionAppModule')
            },
            {
                name: T('moduleMarketing'),
                column: Modules.Marketing,
                route: 'moduleMarketing',
                status: 'active',
                description: T('descriptionMarketingModule')
            }
        ], _this.props.store.users.user.isSupport ?
            [{
                    name: T('civitrip'),
                    column: Modules.Civitrip,
                    route: 'moduleCivitrip',
                    status: 'active',
                    description: T('descriptionMarketingModule')
                }] : [], true);
        _this.handleClick = function (module) {
            history.push("/acount/".concat(module.route));
        };
        _this.handleChange = function (name, value, column) {
            var _a;
            var result = (_a = {}, _a[column ? column : name] = value, _a);
            // @ts-ignore
            _this.setState(__assign({}, result), function () {
            });
        };
        _this.handleSubmit = function () {
            var acount = _this.props.acount;
            if (acount.collaborator) {
                /*if (acount.collaborator.disabled_at === null && this.state.beCollaborator ||
                  acount.collaborator.disabled_at !== null && !this.state.beCollaborator)  {
                  this.props.store.UI.newWarning('nada cambiado')
                  return
                }*/
                acount.collaborator.disabled_at = _this.state.beCollaborator ? null : new Date();
                _this.props.store.acountStore.patch(acount);
            }
            else {
                _this.props.store.acountStore.create({ client_id: acount.id, disabled_at: _this.state.beCollaborator });
            }
        };
        _this.handleCancel = function () {
        };
        _this.state = {
            beCollaborator: _this.props.acount.collaborator ? !!_this.props.acount.collaborator.disabled_at : false,
            primaryMoney: _this.props.store.moneysStore.getPrimaryMoney(),
            webMoney: _this.props.store.moneysStore.getWebMoney(),
            viewSelected: ViewSelected.settings,
            updateLast: null,
            updateAvailable: null,
            isUpToDate: true,
            currentVersion: null,
        };
        _this.modules = _this.modules.map(function (module) {
            var _a;
            switch (module.column) {
                case Modules.Collaborator:
                    var activeModuleCollaborator = !!_this.props.acount.collaborator && !_this.props.acount.collaborator.disabled_at;
                    return __assign(__assign({}, module), { status: activeModuleCollaborator ? 'active' : 'noActive' });
                case Modules.Virtual:
                    var usersVirtuals = (_a = _this.props.users) === null || _a === void 0 ? void 0 : _a.filter(function (user) { return user.role === 'virtual'; });
                    var activeModuleVirtual = (usersVirtuals === null || usersVirtuals === void 0 ? void 0 : usersVirtuals.length) > 0;
                    return __assign(__assign({}, module), { status: activeModuleVirtual ? 'active' : 'noActive' });
                    return module;
                case Modules.Ecommerce:
                    var devicesEcommerce = _this.props.devices;
                    var activeModuleEcommerce = (devicesEcommerce === null || devicesEcommerce === void 0 ? void 0 : devicesEcommerce.length) > 0;
                    return __assign(__assign({}, module), { status: activeModuleEcommerce ? 'active' : 'noActive' });
                default:
                    return module;
            }
        });
        return _this;
    }
    AcountContainer.prototype.render = function () {
        var _this = this;
        var acount = this.props.acount;
        var beCollaborator = this.state.beCollaborator;
        return (React.createElement(React.Fragment, null,
            React.createElement(Wrapper, null,
                React.createElement(Field, { field: {
                        name: 'name',
                        type: FieldType.Label,
                        value: acount.name,
                        size: 10,
                        underline: false
                    }, onChange: this.handleChange }),
                React.createElement(Field, { onChange: function (name, value, column) { return _this.handleChange(name, moneys.find(function (money) { return money.id === Number(value); }), column); }, field: {
                        // value: primaryMoney.id,
                        value: this.props.store.moneysStore.getPrimaryMoney().alphabeticCode,
                        size: 9,
                        name: 'Moneda',
                        column: 'primaryMoney',
                        type: FieldType.Label,
                        underline: false
                        /*options: moneys.map((money: Money) => {
                          return {
                            name: `${money.currency} - ${money.alphabeticCode}` ,
                            value: money.id
                          }
                        })*/
                    } })),
            React.createElement(Wrapper, null,
                React.createElement(Section, null,
                    React.createElement(SectionHeader, null, TT('versionCheck')),
                    this.state.isUpToDate && (this.state.currentVersion !== null && this.state.updateLast !== null) && (this.state.currentVersion === this.state.updateLast) && (React.createElement(React.Fragment, null,
                        React.createElement(View, { style: { backgroundColor: 'green', color: 'white', marginBottom: '25px', margin: '0 25px 0' } }, TT('isUpDate')))),
                    this.state.updateLast && this.state.updateAvailable ? (React.createElement(React.Fragment, null,
                        React.createElement(VersionRow, null,
                            React.createElement(Label, null, "".concat(TT('currentVersion'), ":")),
                            React.createElement(VersionValue, null, this.state.updateLast)),
                        React.createElement(VersionRow, null,
                            React.createElement(Label, null, "".concat(TT('latestVersion'), ":")),
                            React.createElement(VersionValue, null, this.state.updateAvailable)),
                        this.state.updateLast < this.state.updateAvailable &&
                            React.createElement(Label, null, TT('availableVersionIn')),
                        !this.state.isUpToDate && (React.createElement(Button, { style: { marginTop: 10 }, onClick: function () {
                                _this.props.store.acountStore.updateVersion().then(function (result) {
                                    console.log('result actualizando: ', result);
                                    _this.props.store.UI.newWarning(T('updated'));
                                    _this.props.store.acountStore.version();
                                })
                                    .catch(function () { return _this.props.store.UI.newError('Hubo un error al actualizar'); });
                            } }, T('update'))))) : (React.createElement(Button, { onClick: function () {
                            _this.props.store.acountStore.version()
                                .then(function (result) {
                                _this.setState({
                                    currentVersion: result.applied,
                                    updateAvailable: result.available,
                                    updateLast: result.applied,
                                    isUpToDate: result.isUpToDate,
                                });
                            })
                                .catch(function () { return _this.props.store.UI.newError('Hubo un error, por favor inténtelo más tarde'); });
                        } }, TT('checkVersion'))))),
            React.createElement(View, { style: {
                    margin: '0 20px 0 20px'
                } },
                React.createElement(Label, { style: {
                        margin: '0 0 10px 0px',
                    } }, TT('modules')),
                React.createElement(WrapperView, { flex: true }, this.modules.map(function (module, index) {
                    return (React.createElement(WrapperItem, { key: "module_".concat(index), center: true, flex: true, row: true },
                        React.createElement(WrapperTouchable, { active: module.status === 'active', style: {
                                borderRadius: 5,
                            }, onClick: function () { return _this.handleClick(module); } }, module.name),
                        React.createElement(WrapperLabel, { flex: 2, textAlign: 'center', style: {} }, T(module.status)),
                        React.createElement(WrapperLabel, { flex: 10, style: {} }, module.description)));
                })))));
    };
    AcountContainer = __decorate([
        inject('store'),
        observer,
        loading(function (props) { return [
            props.store.acountStore.read().then(function (acount) { return ({ acount: acount }); }),
            props.store.moneysStore.read().then(function (moneys) { return ({ moneys: moneys }); }),
            props.store.users.readVirtuals().then(function (users) { return ({ users: users }); }),
            props.store.devices.readEcommerce().then(function (devices) { return ({ devices: devices }); }),
        ]; })
    ], AcountContainer);
    return AcountContainer;
}(Component));
export default AcountContainer;
var Wrapper = cxs('div')((_a = {
        margin: '0 0 15px 25px',
        display: 'flex',
        flexWrap: 'wrap'
    },
    _a[mediaQueries.desktop] = {
        margin: '0 0 50px 50px',
    },
    _a));
var WrapperView = cxs(View)((_b = {
        margin: '0 10px 0 10px',
        minHeight: '100%'
    },
    _b[mediaQueries.desktop] = {
    // paddingBottom: 0
    },
    _b));
var WrapperItem = cxs(View)(function (_a) {
    var _b;
    var active = _a.active;
    return (_b = {
            color: active ? theme.color.backgreen : undefined
        },
        _b[mediaQueries.desktop] = {
            minHeight: '100px',
            // marginBottom: '10px',
        },
        _b);
});
var WrapperTouchable = cxs(Touchable)(function (_a) {
    var _b;
    var active = _a.active;
    return (_b = {
            flex: 2,
            border: '1px solid black',
            height: '100px',
            backgroundColor: 'lightgray',
            color: active ? 'green' : 'red',
            minWidth: '100px'
        },
        _b[mediaQueries.desktop] = {},
        _b);
});
var WrapperLabel = cxs(Label)(function (_a) {
    var _b;
    var flex = _a.flex, textAlign = _a.textAlign;
    return (_b = {
            flex: flex,
            textAlign: textAlign,
            padding: '10px'
        },
        _b[mediaQueries.desktop] = {},
        _b);
});
var Section = cxs('div')({
    border: '1px solid #ddd',
    borderRadius: 8,
    padding: '15px 20px',
    marginBottom: '20px',
    backgroundColor: '#fafafa',
    maxWidth: 400,
});
var SectionHeader = cxs('h4')({
    margin: '0 0 15px 0',
    fontSize: '16px',
    fontWeight: 600,
    color: '#333',
});
var VersionRow = cxs('div')({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 5,
});
var VersionValue = cxs('span')({
    fontWeight: 500,
    color: theme.color.primary,
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/container/AcountContainer.tsx
// module id = 1576
// module chunks = 0